import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
import { dispatch } from 'redux_data/store';
import { getFirstAndLastDateOfWeek } from 'utils/util'; 

// const [start_date , end_date] = getFirstAndLastDateOfWeek();
const slice = createSlice({
  name: 'bank_statement', // This is the name of the slice
  initialState: {
    hasError: null,
    isLoading: false,
    isLoadingDetail: false,
    start_date: new Date().toISOString().slice(0, 7) + '-01', 
    end_date: new Date().toISOString().slice(0, 10),
    coa_code: null,
    formValue: null,
    postDatas: [],
    reconcileDatas: [],
    datas: [],
    data: {},
  },
  reducers: {
    noError(state) { // NO ERROR
      state.hasError = false;
    },
    unsetError(state) { // UNSET ERROR
      state.hasError = null;
    },
    hasError(state, action) { // HAS ERROR
      state.isLoading = false;
      state.hasError = JSON.stringify(action.payload);
    },
    startLoading: (state, action) => {
      state.isLoading = true;
    },
    startLoadingDetail: (state, action) => {
      state.isLoadingDetail = true;
    },
    setStartDate: (state, action) => {
      state.isLoading = false;
      state.start_date = action.payload;
    },
    setEndDate: (state, action) => {
      state.isLoading = false;
      state.end_date = action.payload;
    },
    setDatas: (state, action) => {
      state.isLoading = false;
      state.datas = action.payload;
    },
    setSalesDatas: (state, action) => {
      state.isLoading = false;
      state.salesDatas = action.payload;
    },
    setData: (state, action) => {
      state.isLoadingDetail = false;
      state.data = action.payload;
    },
    setFormValue: (state, action) => {
      state.formValue = action.payload;
    },
    setCoaCode: (state, action) => {
      state.coa_code = action.payload;
    },
    setReconcileDatas: (state, action) => {
      state.reconcileDatas = action.payload;
    },
    setPostDatas: (state, action) => {
      state.postDatas = action.payload;
    },

  },
});

export const { 
    noError , 
    unsetError , 
    hasError, 
    startLoading , 
    startLoadingDetail , 
    setStartDate ,
    setEndDate ,
    setDatas , 
    setSalesDatas ,
    setData ,
    setFormValue , 
    setReconcileDatas ,
    setPostDatas ,
    setCoaCode ,
} = slice.actions;

const endpoint = "/bank_statement"

export function searchData({ data = {} , params = {}, sales = false } = {data: {} , params: {} , sales:false}) {
  return async (dispatch , getState) => {
    dispatch(slice.actions.startLoading());
    try {
      const state = getState();
      if(!data?.start_date){ data.start_date = state.bank_statement.start_date} ;
      if(!data?.end_date){ data.end_date = state.bank_statement.end_date} ;
      if(!data?.coa_code){ data.coa_code = state.bank_statement.coa_code} ;
      
      let endpointURL = `${endpoint}/search`;
      Object.keys(params).forEach(key => {
        if(endpointURL.includes("?")){
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        }else{
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      })
      const response = await axios.post( endpointURL , data )?.then( resp => resp?.data);
      // console.log("searchData", response);
      if(response?.success){
        if(sales === true){
          dispatch(slice.actions.setSalesDatas(response.data));
          dispatch(slice.actions.setReconcileDatas(response.reconcile_list));
        }else{
          dispatch(slice.actions.setDatas(response.data));
        }
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}


export function addData({formData}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${endpoint}`, formData )?.then( resp => resp?.data);
      // console.log("addData", response);
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function editData({id, formData, encryptedPin}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.patch(`${endpoint}/${id}`, formData )?.then( resp => resp?.data);
      // console.log("editData", response);
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function deleteData({item_list , encryptedPin}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      // console.log(list_id , encryptedPin);
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.put(`${endpoint}/` , { item_list: item_list })?.then( resp => resp?.data);;
      if(response?.success){
        dispatch(slice.actions.noError())
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}


export function saveReconcile(payload) {
  // payload shape:
  //   { bank_statement_id, id_date, tolerance, summary, stmtLines, erpLines }
  return async () => {
    try {
      const res = await axios.post(`${endpoint}/save_reconcile`, payload);
      if (res.data?.success) {
        
        
      }
      return { success: res.data?.success ?? false };
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message ?? 'Failed to save reconciliation'));
      return { success: false };
    }
  };
}

export function loadReconcile({ bank_statement_id, id_date }) {
  return async () => {
    try {
      const res = await axios.post(`${endpoint}/load_reconcile`, {
        bank_statement_id,
        id_date,
      });
      return { success: res.data?.success ?? false, data: res.data?.data ?? null };
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message ?? 'Failed to load reconciliation'));
      return { success: false, data: null };
    }
  };
}

export function clearReconcile({ bank_statement_id, id_date }) {
  return async () => {
    try {
      const res = await axios.post(`${endpoint}/clear_reconcile`, {
        bank_statement_id,
        id_date,
      });
      if (res.data?.success) {
        dispatch(slice.actions.patchStatement({
          bank_statement_id,
          reconcile_meta:   null,
          // Note: we don't null out saved_stmt_lines / saved_erp_lines locally
          // because the list query never fetches them anyway (excluded via attributes).
        }));
      }
      return { success: res.data?.success ?? false };
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message ?? 'Failed to clear reconciliation'));
      return { success: false };
    }
  };
}

export function deleteReconcile({ item_list  }) {
  return async () => {
    try {
      const res = await axios.post(`/bank_statement/delete_reconcile`, {item_list});

      return {
        success: res.data?.success ?? false,
      };
    } catch (err) {
      dispatch(
        slice.actions.hasError(
          err?.message ?? 'Failed to delete reconciliation'
        )
      );
      return { success: false };
    }
  };
}


export default slice.reducer;
